import React, { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { ConvertApexBarChart, XLSXUtil } from '@datatox-bi/util';
import { SiMicrosoftexcel } from 'react-icons/si';
import Chart from 'react-apexcharts';

const defaultColors = [
    '#2E93fA',
    '#66DA26',
    '#546E7A',
    '#E91E63',
    '#FF9800',
    '#ff7f50',
    '#87cefa',
    '#da70d6',
    '#32cd32',
    '#6495ed',
    '#ff69b4',
    '#ba55d3',
    '#cd5c5c',
    '#ffa500',
    '#40e0d0',
];

const ApexBarNegativeChart = ({ datasetDruid, title, uiConfig }) => {
    const [dataset, setDataset] = useState(null);
    useEffect(() => {
        const [categories, series, colors, tickAmount] = ConvertApexBarChart.toApexBarNegativeChart({ datasetDruid: [...datasetDruid], defaultColors, ...uiConfig });
        setDataset([categories, series, colors, tickAmount]);
    }, []);

    if (dataset === null) {
        return 'loading';
    }

    if (datasetDruid.length <= 1) {
        return 'Nenhum dado';
    }

    const [categories, series, colors, tickAmount] = dataset;

    const config = {
        series,
        chart: {
            type: 'bar',
            // height: 600,
            // height: 'auto',
            width: '100%',
            stacked: true,
            animations: {
                enabled: !!uiConfig?.enableAnimation,
            },
        },
        colors: colors,
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '80%',
            },
        },
        stroke: {
            width: 1,
            colors: ['#fff'],
        },
        xaxis: {
            categories,
            tickAmount,
            labels: {
                formatter: function (val) {
                    return Math.abs(val);
                },
            },
        },
        yaxis: {
            title: {
                text: undefined,
            },
        },
        tooltip: {
            shared: false,
            y: {
                formatter: function (val) {
                    return Math.abs(val);
                },
            },
        },
        grid: {
            borderColor: '#90A4AE',
            strokeDashArray: 7,
            xaxis: {
                lines: {
                    show: true,
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        fill: {
            opacity: 1,
        },
        legend: {
            position: 'top',
            horizontalAlign: 'left',
        },
        responsive: [
            {
                // breakpoint: 480,
                options: {
                    chart: {
                        // width: 1000,
                    },
                    legend: {
                        position: 'bottom',
                    },
                },
            },
        ],
    };

    return <Chart options={config} series={config.series} type="bar" />;
};

export default ApexBarNegativeChart;
